import { apiFetch } from './api';
import type { Device, Category } from '../types/models';

export function searchDevices(query: string, category?: Category): Promise<Device[]> {
  return apiFetch<Device[]>('/devices', { params: { q: query, category } });
}

export function getDevice(id: string): Promise<Device> {
  return apiFetch<Device>(`/devices/${id}`);
}

export function listCategories(): Promise<{ category: Category; count: number }[]> {
  return apiFetch<{ category: Category; count: number }[]>('/devices/categories');
}
